export const state = {
    isAnalyticsInit: false,
    isAnalyticsLoading: false,
    analytics: []
};
